import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IUsr0301MState, IUserItemState, IUserExpreState, IInquiryCndsState, ITecnlLvlState, ICertItemState, IDeptCdState, IExTecnlLvlState } from '../../models/usr/usr0301m_model';
  
const initialState: IUsr0301MState = {
    userList: [],       // 사용자정보
    tecnlLvlList: [],   // 기술등급
    exTecnlLvlList: [], // 예상기술등급
    certList:[],        // 자격증
    deptCdList:[],      // 부서
    userExpre: [],      // 경력현황 목록(조회결과)

    inquiryCnds: {
        empNo         : '', // 사원번호
        tecnlLvlCd    : '', // 기술등급
        exTecnlLvlCd  : '', // 예상등급
        certTpCd      : '', // 자격증
        prjExpreStMm  : '', // 시작일자
        prjExpreEndMm : '', // 종료일자
        deptCd : '',        // 부서코드
    },                      // 조회조건

    pageSize : 20,          // 페이징사이즈
    current  : 0,           // 현재페이지
}

export const usr0301m_Slice = createSlice({
    name: "usr0301m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , userList: state.userList
                                   , tecnlLvlList: state.tecnlLvlList
                                   , exTecnlLvlList: state.exTecnlLvlList
                                   , certList: state.certList
                                   , deptCdList: state.deptCdList
                                 });
        },
        setUserExpre: (state, action:PayloadAction<IUserExpreState[]>) => {
            state.userExpre = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setTecnlLvlList: (state, action:PayloadAction<ITecnlLvlState[]>) => {
            state.tecnlLvlList = action.payload;
        },
        setExTecnlLvlList: (state, action:PayloadAction<IExTecnlLvlState[]>) => {
            state.exTecnlLvlList = action.payload;
        },
        setCertList: (state, action:PayloadAction<ICertItemState[]>) => {
            state.certList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
        setDeptCdList: (state, action:PayloadAction<IDeptCdState[]>) => {
            state.deptCdList = action.payload;
        },
    },
});

export default usr0301m_Slice.reducer;
export const Usr0301mAction  = usr0301m_Slice.actions;
export const Usr0301mReducer = usr0301m_Slice.reducer;